import { ChevronRight, Settings, UserRound } from "lucide-react";
import { useEffect, useState } from "react";
import type { NavigationKey } from "../../app/navigation";

type ProfileMenuProps = {
  roleLabel: string;
  onNavigate: (key: NavigationKey) => void;
};

export function ProfileMenu({ roleLabel, onNavigate }: ProfileMenuProps) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [open]);

  return (
    <div className="dropdown-container">
      <button
        aria-expanded={open}
        aria-label={`Open profile for ${roleLabel}`}
        className="profile-button"
        onClick={() => setOpen((current) => !current)}
        type="button"
      >
        <UserRound aria-hidden="true" size={19} />
      </button>
      {open && (
        <div className="dropdown-menu dropdown-menu--right profile-menu">
          <div className="dropdown-header profile-summary">
            <img src="/brand/icon-192.png" alt="" className="profile-avatar" />
            <span><strong>Demonstration operator</strong><small>{roleLabel} · Cedar Reach College</small></span>
          </div>
          <button
            className="dropdown-item"
            onClick={() => {
              setOpen(false);
              onNavigate("administration");
            }}
            type="button"
          >
            <Settings aria-hidden="true" size={19} />
            <span><strong>Administration</strong><small>Role and environment settings</small></span>
            <ChevronRight aria-hidden="true" size={17} />
          </button>
        </div>
      )}
    </div>
  );
}
